import { fetcher } from "../network";
import { API } from "../network/api";

const publicVapidKey =
  "BF1ANQFB70ihu-WDe8S6GbqqO0TfzsKH3uVHQonahks5d8hZdbx8Wy0YOy9ZU3S3nr0Gcmt4Ncks7cV9jy346Ow";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerNotification(homeId: string) {
  return;
  await navigator.serviceWorker.register("/service-worker.js", {
    scope: "/",
  });

  return;
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;
      if (!registration.pushManager) {
        return;
      }
      const existedSubscription =
        await registration.pushManager.getSubscription();
      if (existedSubscription === null) {
        const newSubscription = await registration.pushManager.subscribe({
          applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
          userVisibleOnly: true,
        });
        sendSubscription(newSubscription, homeId);
      } else {
        //@ts-ignore
        sendSubscription(existedSubscription, homeId);
      }
    } catch (error) {
      console.log(error);
    }
  }
}

function sendSubscription(
  subscription: globalThis.PushSubscription,
  homeId: string
) {
  fetcher().post(API.POST.SUBSCRIBE_NOTIFICATION, {
    subscription,
    homeId,
  });
}
